import { createSlice } from "@reduxjs/toolkit";
import {
  createChartDataState, finishScopedRequest, prepareChartRequest,
  removeScopedSeries, resetChartScope, startScopedRequest,
} from "../../../utils/scopedChartDataUtils";

const initialState = { ...createChartDataState(), scopes: {} };

const sensorDataSlice = createSlice({
  name: "sensorData",
  initialState,
  reducers: {
    fetchSensorDataStart: {
      prepare: prepareChartRequest,
      reducer(state, action) {
        const payload = action.payload;
        if (startScopedRequest(state, payload, payload?.id)) return;
        state.pendingRequests += 1;
        state.isLoading = true;
        state.error = null;
        state.success = false;
      },
    },
    fetchSensorDataSuccess(state, action) {
      const { sensorId, measure, data } = action.payload;
      const key = `${sensorId}_${measure}`;
      if (finishScopedRequest(state, action.payload, sensorId)) return;

      state.pendingRequests = Math.max(0, state.pendingRequests - 1);
      state.isLoading = state.pendingRequests > 0;
      state.data = {
        ...state.data,
        [key]: data,
      };
      state.success = true;
    },
    fetchSensorDataFailure(state, action) {
      const payload = action.payload;
      if (finishScopedRequest(state, payload, payload?.sensorId, true)) return;
      state.pendingRequests = Math.max(0, state.pendingRequests - 1);
      state.isLoading = state.pendingRequests > 0;
      state.error = action.payload;
      state.success = false;
    },
    resetSensorData(state, action) {
      resetChartScope(state, action.payload);
    },
    removeSensorData(state, action) {
      const { sensorId, measure } = action.payload;
      const key = `${sensorId}_${measure}`;
      if (removeScopedSeries(state, action.payload, sensorId)) return;
      delete state.data[key];
    },
    clearAllSensorData(state, action) {
      resetChartScope(state, action.payload);
    },
  },
});

export const {
  fetchSensorDataStart,
  fetchSensorDataSuccess,
  fetchSensorDataFailure,
  resetSensorData,
  removeSensorData,
  clearAllSensorData,
} = sensorDataSlice.actions;

export default sensorDataSlice.reducer;
